import { axiosInstance } from "@/plugins/axios";
import {ProductMaterialAssociation} from "@/modules/product_material_association/types";

export async function saveProductMaterialAssociations(associations: ProductMaterialAssociation[]) {
  return await axiosInstance.post(`product_material_associations/create_or_update_many`, {
    associations
  });
}
